<template>
  <div class="lobby-container">
    <div class="scoreboard-modal" v-if="scoreOpen">
      <div id="close-scoreboard" @click="toggleScore"></div>
      <div class="scoreboard-content">
        <h3>Game Over</h3>
        <table>
          <thead>
            <tr>
              <th>Player</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(player, index) in score" :key="index">
              <td>{{ player.userName }}</td>
              <td>{{ player.points }}</td>
            </tr>
          </tbody>
        </table>

        <button class="close-scoreboard" @click="restartGame">
          Play Again
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let score = []

    if (this.$route.query.score) {
      try {
        const decoded = decodeURIComponent(this.$route.query.score)
        const obj = JSON.parse(decoded)
        score = Object.entries(obj).map(([userName, points]) => ({
          userName,
          points,
        }))
        // Optional: sort descending
        score.sort((a, b) => b.points - a.points)
      } catch (err) {
        console.error('Error parsing score:', err)
      }
    }

    return {
      score,
      scoreOpen: true, // Modal opens by default
    }
  },
  methods: {
    restartGame() {
      this.$router.push('/lobby')
    },
  },
}
</script>

<style scoped>
/* Modal Overlay */
.scoreboard-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Click outside area */
#close-scoreboard {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

/* Modal content box */
.scoreboard-content {
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 2rem;
  border-radius: 20px;
  max-width: 90%;
  width: 500px;
  text-align: center;
  z-index: 200;
}

/* Titles */
.scoreboard-content h3 {
  color: #e74c3c;
  margin-bottom: 10px;
}

.scoreboard-content h2 {
  margin-top: 20px;
}

/* Subtitle */
.subtitle {
  font-size: 1rem;
  color: #ccc;
  margin-bottom: 20px;
}

/* Table Styling */
.scoreboard-content table {
  width: 100%;
  margin: 0 auto;
  border-collapse: collapse;
  background: #222;
  border-radius: 10px;
  overflow: hidden;
}

.scoreboard-content th,
.scoreboard-content td {
  padding: 10px;
  border-bottom: 1px solid #444;
}

.scoreboard-content th {
  background: #333;
}

/* Restart Button */
.close-scoreboard {
  margin-top: 20px;
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
}

.close-scoreboard:hover {
  background: #218838;
}
</style>
